import styled from "@emotion/styled";
import { FC } from "react";
import { OpenBrowser } from "src/hybrid/components/Browser";

const Card = styled.button`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  max-width: 9.75rem;
  height: 13.375rem;
  border-radius: 0.5rem;
  overflow: hidden;
  /* Own stacking context so the image layers within the card and can't be hidden behind an
     ancestor's background (e.g. the Transcarent partner theme's opaque modal background). */
  isolation: isolate;
  /* Reset button styles for card appearance */
  margin: 0;
  border: none;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
  padding: 0;
  width: 100%;
`;

const BackgroundImage = styled.img`
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
`;

const CardOverlay = styled.div`
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0.75rem 0.75rem 1rem;
  gap: 0.5rem;
  border-radius: 0 0 0.5rem 0.5rem;
  overflow: hidden;

  height: 5.5rem;

  background: rgba(0, 0, 0, 0.43);
  backdrop-filter: blur(6px);

  span {
    color: var(--color-white);
    margin: 0;

    /* CSS text truncation */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
  }
`;

interface Props {
  title: string;
  image: string;
  url: string;
  imageAlt: string;
}

export const ArticleCard: FC<Props> = ({ title, image, url, imageAlt }) => {
  const handleOpenArticle = () => {
    void OpenBrowser(url, {
      useBaseUrl: false,
      presentationStyle: "fullscreen"
    });
  };

  return (
    <Card type="button" onClick={handleOpenArticle} aria-label={title}>
      <CardOverlay>
        <span className="as-little strong">{title}</span>
      </CardOverlay>
      <BackgroundImage src={image} alt={imageAlt} />
    </Card>
  );
};
